import api from 'api';

export const createPostback = api('POST /api/integrations/postbacks');

export const loadPostback = api('GET /api/integrations/postbacks/:id');

export const editPostback = api('PUT /api/integrations/postbacks/:id/edit');

export const loadPostbackDetails = api(
  'GET /api/integrations/postbacks/:id/details'
);
